const _excluded = ["className"],
  _excluded2 = ["children"],
  _excluded3 = ["children"],
  _excluded4 = ["children"],
  _excluded5 = ["children", "className"],
  _excluded6 = ["children", "className"],
  _excluded7 = ["children", "className"],
  _excluded8 = ["children"],
  _excluded9 = ["children"],
  _excluded10 = ["children", "toInternalLink", "onClick", "target", "toExternalLink"],
  _excluded11 = ["toInternalLink"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import { Link, useLocation } from 'react-router-dom';
import cn from 'classnames';
import { Typography, Button, TextButton } from 'seagull';
import styles from "./FormComponents.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export const FormContainer = props => {
  const {
      className
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_jsx("form", _objectSpread(_objectSpread({}, rest), {}, {
    className: cn(styles.formContainer, className)
  }));
};
export const FormTitle = props => {
  const {
      children
    } = props,
    rest = _objectWithoutProperties(props, _excluded2);
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, rest), {}, {
    className: styles.title,
    children: children
  }));
};
export const FormSubTitle = props => {
  const {
      children
    } = props,
    rest = _objectWithoutProperties(props, _excluded3);
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, rest), {}, {
    className: styles.subTitle,
    children: children
  }));
};
export const FormDescription = props => {
  const {
      children
    } = props,
    rest = _objectWithoutProperties(props, _excluded4);
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, rest), {}, {
    className: styles.description,
    children: children
  }));
};
export const FormFields = props => {
  const {
      children,
      className
    } = props,
    rest = _objectWithoutProperties(props, _excluded5);
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, rest), {}, {
    className: cn(styles.formFields, className),
    children: children
  }));
};
export const VerticalFormFields = props => {
  const {
      children,
      className
    } = props,
    rest = _objectWithoutProperties(props, _excluded6);
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, rest), {}, {
    className: cn(styles.verticalFormFields, className),
    children: children
  }));
};
export const HorizontalFormFields = props => {
  const {
      children,
      className
    } = props,
    rest = _objectWithoutProperties(props, _excluded7);
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, rest), {}, {
    className: cn(styles.horizontalFormFields, className),
    children: children
  }));
};
export const Footer = props => {
  const {
      children
    } = props,
    rest = _objectWithoutProperties(props, _excluded8);
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, rest), {}, {
    className: styles.footer,
    children: children
  }));
};
export const FooterText = props => {
  const {
      children
    } = props,
    rest = _objectWithoutProperties(props, _excluded9);
  return /*#__PURE__*/_jsx(Typography, _objectSpread(_objectSpread({}, rest), {}, {
    as: "span",
    variant: "paragraph2",
    skin: "disabled",
    weight: "light",
    children: children
  }));
};
export const FooterLink = props => {
  const {
      children,
      toInternalLink,
      onClick,
      target,
      toExternalLink
    } = props,
    rest = _objectWithoutProperties(props, _excluded10);
  const location = useLocation();
  let as, componentProps;
  if (toExternalLink || toInternalLink) {
    as = Link;
    const to = toInternalLink ? {
      pathname: toInternalLink,
      search: location.search
    } : {
      pathname: toExternalLink
    };
    componentProps = {
      to,
      target
    };
  } else {
    as = 'button';
    componentProps = {
      type: 'button'
    };
  }
  return /*#__PURE__*/_jsx(TextButton, _objectSpread(_objectSpread(_objectSpread({}, rest), componentProps), {}, {
    as: as,
    onClick: onClick,
    size: "small",
    skin: "secondary",
    underline: "none",
    children: children
  }));
};
export const SubmitButtonField = props => {
  const {
    disabled,
    isLoading,
    children
  } = props;
  return /*#__PURE__*/_jsx("div", {
    className: styles.submitButtonField,
    children: /*#__PURE__*/_jsx(Button, {
      disabled: disabled,
      loading: isLoading,
      type: "submit",
      "data-testid": props['data-testid'],
      children: children
    })
  });
};
export const ErrorMessage = props => {
  return /*#__PURE__*/_jsx(Typography, _objectSpread(_objectSpread({}, props), {}, {
    skin: "error",
    variant: "paragraph2",
    "data-testid": props['data-testid'],
    className: styles.error,
    children: props.children
  }));
};
export const LinkButton = props => {
  const {
      toInternalLink
    } = props,
    rest = _objectWithoutProperties(props, _excluded11);
  return /*#__PURE__*/_jsx(TextButton, _objectSpread({
    as: Link,
    to: {
      pathname: toInternalLink,
      search: location.search
    },
    skin: "secondary",
    size: "small",
    underline: "none"
  }, rest));
};